import * as React from "react";

import { Avatar, Grid, Box, Paper, Typography } from "@mui/material";

import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import SignUpForm from "./components/SignUpForm";

import { getLanguage } from "../../config/language/language.js";

/**
 * Sign up page.
 */
export default function SignUp(props) {
    return (
        <Grid container component="main" sx={{ height: "75vh" }}>
            <Grid
                item
                id="signUpBackground"
                xs={false}
                sm={4}
                md={7}
                sx={{
                    backgroundImage: `url("${process.env.PUBLIC_URL}/images/signout.jpeg")`,
                    backgroundRepeat: "no-repeat",
                    backgroundColor: (t) => (t.palette.mode === "light" ? t.palette.grey[50] : t.palette.grey[900]),
                    backgroundSize: "cover",
                    backgroundPosition: "center"
                }}
            />

            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <Box
                    sx={{
                        my: 4,
                        mx: 4,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center"
                    }}>
                    <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
                        <LockOutlinedIcon />
                    </Avatar>

                    <Typography component="h1" variant="h5">
                        {getLanguage().BUTTON_SIGNUP}
                    </Typography>

                    <SignUpForm {...props} />
                </Box>
            </Grid>
        </Grid>
    );
}
